var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerticalTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    className: "backgroundHighlight"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C8.44772 7 8 7.44772 8 8V32C8 32.5523 8.44772 33 9 33C9.55228 33 10 32.5523 10 32V31H15C15.5523 31 16 30.5523 16 30C16 29.4477 15.5523 29 15 29H10V26H12C12.5523 26 13 25.5523 13 25C13 24.4477 12.5523 24 12 24H10V21H17C17.5523 21 18 20.5523 18 20C18 19.4477 17.5523 19 17 19H10V16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14H10V11H14C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9H10V8C10 7.44772 9.55228 7 9 7Z",
    className: "textCallout"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3759 14.5332C26.4627 14.3317 26.7484 14.3317 26.8352 14.5332L28.1691 17.6308C28.2053 17.7148 28.2845 17.7724 28.3756 17.7808L31.7338 18.0923C31.9523 18.1126 32.0406 18.3843 31.8757 18.529L29.342 20.7549C29.2732 20.8153 29.243 20.9084 29.2631 20.9977L30.0046 24.2878C30.0529 24.5018 29.8217 24.6697 29.6331 24.5577L26.7332 22.8358C26.6545 22.7891 26.5566 22.7891 26.4779 22.8358L23.578 24.5577C23.3894 24.6697 23.1582 24.5018 23.2065 24.2878L23.948 20.9977C23.9681 20.9084 23.9379 20.8153 23.8691 20.7549L21.3353 18.529C21.1705 18.3843 21.2588 18.1126 21.4772 18.0923L24.8354 17.7808C24.9266 17.7724 25.0058 17.7148 25.042 17.6308L26.3759 14.5332Z",
    className: "textCallout"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalTimeline);
export default __webpack_public_path__ + "static/media/vertical-timeline.536ac237bd61a55f9ebdd1281e7a2ebb.svg";
export { ForwardRef as ReactComponent };